module.exports = __webpack_public_path__ + "img/MusubiMaster.d92813c.png";